<template>
  <v-app>
    <!-- 1°first ROW -->
    <div class="row">
      <div class="col-md-12">
        <!-- 1°first Card -->
        <v-card outlined tile elevation="1">
          <v-card-title>
            Ubicación
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on}">
                <v-btn v-on="on" class @click="reinitialize" text icon color="blue">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Actualizar Tabla</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class @click="exportExcel" text icon color="green">
                  <v-icon>fas fa-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Exportar Excel</span>
            </v-tooltip>
          </v-card-title>
          <div v-if="loadTransition"  class="alert bluesky-line m-0 mb-0" ></div>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="localizacion"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              :search="search"
              sort-by="id"
              class="elevation-1 datatable"
            >
              <template v-slot:top>
                <v-card class="mt-1">
                <v-spacer></v-spacer>
                <v-toolbar flat color="white">
                  <div class="kt-input-icon kt-input-icon--left">
                    <input
                      v-model="search"
                      append-icon="search"
                      label="Búsqueda"
                      type="text"
                      class="form-control form-control-md col-md-8"
                      placeholder="Buscar..."
                    />
                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                      <span>
                        <i class="la la-search"></i>
                      </span>
                    </span>
                  </div>
                  <!--<v-text-field
                    class="text-xs-center"
                    v-model="search"
                    append-icon="search"
                    label="Búsqueda"
                  ></v-text-field>-->
                  <v-spacer></v-spacer>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-dialog v-model="dialog" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark class="mb-2 btn-starkoms-primary" v-bind="attrs" v-on="on">
                        <i class="fa fa-plus mr-2"></i> Ubicación
                      </v-btn>
                    </template>
                    <!-- 2°second Card -->
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <!-- 2°second ROW -->
                            <v-row>
                              <v-col cols="12" sm="2" md="2" v-if="editedItem.id">
                                <v-text-field
                                  v-model="editedItem.id"
                                  name="id"
                                  label="ID"
                                  readonly="readonly"
                                  prepend-icon="vpn_key"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field
                                  v-model="editedItem.code"
                                  :rules="[v => !!v || 'El codígo de la Ubicación es requerido!']"
                                  label="Codigo"
                                  prepend-icon="edit_location"
                                ></v-text-field>+
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-select
                                  v-model="editedItem.warehouse_id"
                                  :items="warehouses"
                                  :rules="[v => !!v || 'Seleccionar una Bodega es requerido!']"
                                  item-value="id"
                                  item-text="name"
                                  label="Bodegas"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#FF6347" text @click="close">Cancelar</v-btn>
                        <v-btn color="#00FF00" text @click="save">Guardar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                </v-card>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on}">
                    <router-link :to="`/inventario/locations/${item.id}`">
                      <v-icon v-on="on" color="#93a2dd" small class="mr-2">mdi-eye</v-icon>
                    </router-link>
                  </template>
                  <span>Ver Detalles de la Ubicación {{item.id}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on}">
                    <v-icon small v-on="on" color="#93a2dd" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                  </template>
                  <span>Editar Ubicación {{item.id}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on}">
                    <v-icon v-on="on" small color="#93a2dd" @click="deleteItem(item)">mdi-delete</v-icon>
                  </template>
                  <span>Eliminar Ubicación {{item.id}}</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <v-btn color="#87CEFA" :loading="loading" @click="reinitialize()">Cargando ..</v-btn>
              </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount" :total-visible="10"></v-pagination>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </v-app>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

export default {
  props: {
    store_id: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    dialog: false,
    valid: true,
    url: "",
    loading: false,
    boolean: false,
    loadTransition: false,
    search: "",
    dateMsg:
      new Date().toISOString().substr(0, 10) +
      " " +
      new Date().toISOString().substr(11, 5),
    headers: [
      {
        text: "ID",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Codígo", value: "code" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    localizacion: [],
    warehouses: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      code: "",
      default: 0,
      store_id: 0,
      warehouse_id: 0,
    },
    defaultItem: {
      id: 0,
      code: "",
      default: 0,
      store_id: 0,
      warehouse_id: 0,
    },
  }),
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Ubicación", route: "/inventario/locations" },
    ]);
    this.loading = true;
    this.fetchWarehouses();
    this.fetchLocations();
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nueva Ubicación"
        : "Editar Ubicación";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    $route(to, from) {
      // react to route changes...
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (localStorage.getItem("deleteLocation") !== null) {
        this.deletedLocationMessage();
      }
      /*     this.localizacion = [
        { id: 1, code: "Location 1", default: 1, store_id: 1, warehouse_id: 1 },
        { id: 2, code: "Location 2", default: 2, store_id: 1, warehouse_id: 1 },
        { id: 3, code: "Location 3", default: 3, store_id: 1, warehouse_id: 1 },
      ]; 

       this.warehouses = [
        {
           id: 1,
           name: "Nombre Bodega 1"
        },
        {
           id: 2,
           name: "Nombre Bodega 2"
        }
    ];*/
    },

    editItem(item) {
      this.editedIndex = this.localizacion.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      var vm = this;
      let deleteLocalizacion = Object.assign({}, item);

      console.log(deleteLocalizacion.id);

      const confirmacion = confirm(
        `Esta seguro de eliminar la Ubicación: ${deleteLocalizacion.code} || ID: ${deleteLocalizacion.id}?`
      );
      if (confirmacion) {
        vm.axios({
          url: "inventory/locations/" + deleteLocalizacion.id,
          method: "DELETE",
        })
          .then((response) => {
            vm.fetchLocations();

            vm.$bvToast.toast(
              `La Ubicación: ${deleteLocalizacion.code}, ha sido eliminada, el ${vm.dateMsg} exitosamente!`,
              {
                title: `Información`,
                variant: "success",
                solid: true,
                toaster: "b-toaster-bottom-center",
              }
            );
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    viewItem(item) {
      console.log(Object.assign({}, item));
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      var vm = this;

      if (this.editedIndex > -1) {
        //Object.assign(this.localizacion[this.editedIndex], this.editedItem);
        let editLocation = Object.assign({}, this.editedItem);

        if (!editLocation.code.length || editLocation.code == null) {
          vm.$bvToast.toast("El Codígo de la Ubicación no debe ir vacío!", {
            title: `Formulario Invalido`,
            variant: "danger",
            solid: true,
            toaster: "b-toaster-bottom-center",
          });
          vm.$refs.form.$el[1].focus();
          return;
        }

        if (
          editLocation.warehouse_id === 0 ||
          isNaN(editLocation.warehouse_id)
        ) {
          vm.$bvToast.toast("Seleccione una Bodega porfavor", {
            title: `Formulario Invalido`,
            variant: "danger",
            solid: true,
            toaster: "b-toaster-bottom-center",
          });
          vm.$refs.form.$el[2].focus();
          return;
        }

        if (this.$refs.form.validate()) {

          vm.loadTransition = true;

          this.axios({
            url: "inventory/locations/" + editLocation.id,
            method: "PUT",
            data: {
              code: editLocation.code,
              default: editLocation.default,
              warehouse_id: editLocation.warehouse_id,
              store_id: editLocation.store_id,
            },
          })
            .then((response) => {
              vm.fetchLocations();

              vm.$bvToast.toast(
                `La Ubicación: ${editLocation.code}, ha sido Actualizada el ${vm.dateMsg} exitosamente!`,
                {
                  title: `Información`,
                  variant: "success",
                  solid: true,
                  toaster: "b-toaster-bottom-center",
                }
              );
              vm.loadTransition = false;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else {
        // console.log(Object.assign(this.editItem));
        //this.localizacion.push(this.editedItem);
        let createLocation = Object.assign({}, this.editedItem);
        //console.log({ "crear locacion": createLocation });

        if (!createLocation.code.length || createLocation.code == null) {
          vm.$bvToast.toast("El Codígo de la Ubicación no debe ir vacío!", {
            title: `Formulario Invalido`,
            variant: "danger",
            solid: true,
            toaster: "b-toaster-bottom-center",
          });
          vm.$refs.form.$el[0].focus();
          return;
        }

        if (
          createLocation.warehouse_id === 0 ||
          isNaN(createLocation.warehouse_id)
        ) {
          vm.$bvToast.toast("Seleccione una Bodega porfavor", {
            title: `Formulario Invalido`,
            variant: "danger",
            solid: true,
            toaster: "b-toaster-bottom-center",
          });
          vm.$refs.form.$el[1].focus();
          return;
        }

        if (this.$refs.form.validate()) 
        {
          vm.loadTransition = true;
        
        this.axios({
            url: "inventory/locations",
            method: "POST",
            data: {
              code: createLocation.code,
              default: createLocation.default,
              warehouse_id: createLocation.warehouse_id,
            },
          })
            .then((response) => {
              vm.fetchLocations();

              vm.$bvToast.toast(
                `La Ubicación: ${createLocation.code}, ha sido guardada Exitosamente!`,
                {
                  title: `Información`,
                  variant: "success",
                  solid: true,
                  toaster: "b-toaster-bottom-center",
                }
              );
              vm.loadTransition = false;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      this.close();
    },
    fetchLocations() {
      var vm = this;
      this.axios({
        url: "inventory/locations",
        method: "GET",
        data: {
          store_id: vm.store_id,
        },
      })
        .then((response) => {
          console.log(response.data.data);
          this.loading = false;
          //console.log(Math.ceil((response.data.data.length/2)));

          vm.pageCount = Math.ceil(response.data.data.length / 10);
          vm.localizacion = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchWarehouses() {
      var vm = this;
      this.axios({
        url: "inventory/warehouse/by_store",
        method: "GET",
      })
        .then((response) => {
          console.log(response.data.data);
          vm.warehouses = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deletedLocationMessage() {
      let deletedLocation = JSON.parse(localStorage.getItem("deleteLocation"));

      this.$bvToast.toast(
        `La Ubicación: ${deletedLocation.code} ha sido eliminada, el ${this.dateMsg} exitosamente!`,
        {
          title: `Información`,
          variant: "success",
          solid: true,
          toaster: "b-toaster-bottom-center",
        }
      );

      localStorage.removeItem("deleteLocation");
    },
    reinitialize() {
      this.localizacion = [];
      this.loading = true;
      this.fetchLocations();
    },
    exportExcel() {
      var vm = this;
      let headers = vm.headers.map((e) => e.text);
      let datos = vm.localizacion;
      this.axios({
        url: "excel/from_array",
        method: "POST",
        data: {
          data: datos,
          cabeceras: headers,
        },
        responseType: "blob",
      })
        .then((response) => {
          const newBlob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
          });
          const data = window.URL.createObjectURL(newBlob);
          window.open(data, "_blank");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>